import React from 'react'
import F1Heading from '@shared/components/F1Components/F1Heading'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '../myImage'
import DetailShape from 'assets/images/detail-shape.png'
import F1TeamSlider from './f1TeamSlider'
import BreadcrumbNav from '../breadcrumbNav'
import Link from 'next/link'
const TeamDriverCard = ({ driverData, teamName }) => {
  const hasValidSlug = driverData?.seos?.[0]?.sSlug

  const renderCardContent = () => (
    <>
      <div className={`${styles.teamPerson}`} style={{ backgroundImage: `url(${DetailShape.src})` }}>
        <MyImage
          src={driverData?.sImgUrl}
          width={259}
          height={259}
          alt={`${driverData?.sName} ${driverData?.sFamilyName}`}
        />
      </div>
      <div className={styles.teamCardContent}>
        <h6>{driverData?.nPermanentNumber}</h6>
        <p>{driverData?.sName} {driverData?.sFamilyName}</p>
        <span>{teamName}</span>
      </div>
    </>
  )

  return hasValidSlug ? (
    <Link href={`/${driverData.seos[0].sSlug}`}>
      <a className={styles.teamDetailCard}>
        {renderCardContent()}
      </a>
    </Link>
  ) : (
    <div className={styles.teamDetailCard}>
      {renderCardContent()}
    </div>
  )
}
function F1TeamDetail({ teamData }) {
  const { data } = teamData
  const driver1Data = data?.aDrivers?.[0]
  const driver2Data = data?.aDrivers?.[1]

  return (
    <>
      <div className="px-2 pt-4">
        <BreadcrumbNav />
      </div>
      <div className={styles.teamSection}>
        <div className={styles.audioWide}>
          <F1Heading title={data?.oTeam?.sName} />
        </div>
        <div className={styles.teamLogoSection}>
          <div className={styles.teamLogoWrapper}>
            <MyImage src={data?.sTeamLogoImgUrl} width={300} height={114} alt="Mercedes Logo" />
          </div>
          <div className={styles.teamCarWrapper}>
            <MyImage src={data?.sCarImgUrl} width={580} height={126} alt="Mercedes Car" />
          </div>
        </div>
        <div className={styles.teamDetailWrapper}>
          <div className={styles.teamDetailLeft}>
            <TeamDriverCard driverData={driver1Data} teamName={data?.oTeam?.sName} />
            <TeamDriverCard driverData={driver2Data} teamName={data?.oTeam?.sName} />
          </div>
          <div className={styles.teamDetailRight}>
            <div className={styles.teamPersonContent}>
              <span>Full Team Name</span>
              {data?.oTeam?.sName}
            </div>
            <div className={styles.teamPersonContent}>
              <span>Base</span>
              {data?.sBase}
            </div>
            <div className={styles.teamPersonContent}>
              <span>Team Chief</span>
              {data?.sTeamChief}
            </div>
            <div className={styles.teamPersonContent}>
              <span>Technical Chief</span>
              {data?.sTechnicalChief}
            </div>
            <div className={styles.teamPersonContent}>
              <span>Chassis</span>
              {data?.sChassis}
            </div>
            <div className={styles.teamPersonContent}>
              <span>Power Unit</span>
              {data?.sPowerUnit}
            </div>
            <div className={styles.teamPersonContent}>
              <span>First Team Entry</span>
              {data?.sFirstTeamEntry}
            </div>
            <div className={styles.teamPersonContent}>
              <span>World Championships</span>
              {data?.nWorldChampionshipsWins}
            </div>
            <div className={styles.teamPersonContent}>
              <span>Highest Race Finish</span>
              {data?.sHighestRaceFinish}
            </div>
          </div>
        </div>
        <F1TeamSlider data={data} />
        <div className={styles.yearTimeline}>
          <h5>Year Wise Timeline</h5>
          <p>{data?.sInProfile}</p>
          {data?.aTimeline?.map((d, i) => {
            return (
              <div key={i} className={styles.yearTimelineCrad}>
                <h6>{d?.nYear}</h6>
                <p>{d?.sDescription}</p>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

F1TeamDetail.propTypes = {
  teamData: PropTypes.object
}

TeamDriverCard.propTypes = {
  driverData: PropTypes.shape({
    seos: PropTypes.arrayOf(
      PropTypes.shape({
        sSlug: PropTypes.string
      })
    ),
    sImgUrl: PropTypes.string,
    sName: PropTypes.string,
    sFamilyName: PropTypes.string,
    nPermanentNumber: PropTypes.number
  }),
  teamName: PropTypes.string
}

export default F1TeamDetail
